// Assignment is known before the caregiver's display record is loaded. Keep it
// usable for both rendering and saving, even if the lookup fails or finds no row.
export function setAssignedVisitCaregiver(target, id, { snapshot, dictionary, lookup }) {
    if (id === null || id === undefined) return;

    const record = Object.values(dictionary || {}).find(caregiver => caregiver.id === id);
    const assigned = { ...(record || snapshot), id };
    assigned.displayName = assigned.displayName ||
        [assigned.firstName, assigned.lastName].filter(Boolean).join(" ") ||
        `Caregiver #${id}`;
    target.caregiver = assigned;

    if (record) return;

    return lookup(id).then(caregiver => {
        // A user may select a replacement or explicitly unassign while loading.
        if (caregiver !== null && target.caregiver === assigned) {
            target.caregiver = caregiver;
        }
    }, () => {
        // A display lookup failure must never turn into an unassignment.
    });
}
